import {coachingApi} from '../api';
import {List, Map} from 'immutable';
import CoachingPlan from 'records/CoachingPlan';
import DirectReportsSource from 'sources/coaching/DirectReportsSource';

export default {
  update(plan) {
    return coachingApi.putJson('/plans', plan.toJS());
  },

  create(plan) {
    return (
      coachingApi
        .postJson('/plans', plan.toJS())
        // api only returns ID instead of hydrated object.  Hide that
        .then(planId => {
          return plan.set('id', planId);
        })
    );
  },

  delete(planId) {
    return coachingApi.delete(`/plans/${planId}`);
  },

  retrieve(planId, params) {
    return coachingApi.getJson(`/plans/${planId}`, {params}).then(plan => new CoachingPlan(plan));
  },

  export(planId) {
    return coachingApi.getJson(`/plans/export/${planId}`);
  },

  fetchAll(params) {
    return coachingApi
      .getJson('/plans', {params})
      .then(plans => List(plans.map(plan => new CoachingPlan(plan))));
  },

  fetchForCoaches(coachIds, params) {
    return coachingApi
      .postJson(`/plans/fetch`, {coachIds, ...params})
      .then(plans => List(plans.map(plan => new CoachingPlan(plan))));
  },

  fetchForManagerWithReviewsInRange(start, end) {
    // The manager is the session user.
    return coachingApi
      .getJson(`/plans/having_reviews_completed_in_period`, {
        params: {start, end},
      })
      .then(plans => List(plans.map(plan => new CoachingPlan(plan))));
  },

  async fetchPastPlansForCoach(coachId, start, end) {
    const pastPlans = await coachingApi.getJson(`/plans/completed_by_coach_and_dates`, {
      params: {
        coachId,
        start,
        end,
      },
    });
    return DirectReportsSource.planVelocities(pastPlans.map(plan => plan.id)).then(velocities =>
      pastPlans.map(plan =>
        Map({
          plan: new CoachingPlan(plan),
          velocity: velocities.find(velocity => velocity.planId === plan.id),
        })
      )
    );
  },

  fetchLastCompleteAndOverdue(coachIds, end) {
    return coachingApi.postJson(`/plans/last_complete_and_overdue`, {coachIds, end}).then(plans =>
      Map(plans).map(({lastCompleted, overdue}) => ({
        lastCompleted: lastCompleted ? new CoachingPlan(lastCompleted) : null,
        overdue: List(overdue.map(o => new CoachingPlan(o))),
      }))
    );
  },
};
